<template>
	<div class="profile-menu-mobile">
		<div class="profile-menu-mobile__header">
			<div class="grid-container">
				<div class="grid-x grid-margin-x">
					<div class="cell small-12 profile-menu-mobile__title" @click="toggle">
						<span>
							{{ header }}
						</span>
						<button class="profile-menu-mobile__toggle">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 7" fill="#7F8BA1" v-if="toggleMenu" v-bind:svg-inline="''" v-bind:class="'profile-menu-mobile__svg profile-menu-mobile__svg--up'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M7.1 0c.2 0 .5.1.6.2l6 5c.4.4.5 1 .1 1.4s-1 .5-1.4.1L7.1 2.3 1.7 6.8c-.4.3-1 .3-1.4-.2-.4-.4-.3-1.1.1-1.4l6-5c.2-.1.5-.2.7-.2" fill-rule="evenodd" clip-rule="evenodd"/></svg>
							<svg width="14" height="7" viewBox="0 0 14 7" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:svg-inline="''" v-bind:class="'profile-menu-mobile__svg profile-menu-mobile__svg--down'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M7 7a.998.998 0 01-.64-.232l-6-5A1.001 1.001 0 011.64.232l5.36 4.466L12.358.232a1.001 1.001 0 011.282 1.536l-6 5a.998.998 0 01-.64.232" fill-rule="evenodd"/></svg>
						</button>
					</div>
				</div>
			</div>
		</div>
		<transition-expand>
			<div class="profile-menu-mobile__item" v-if="toggleMenu == true">
				<div class="grid-container">
					<div class="grid-x grid-margin-x">
						<div class="cell small-12" @click="() => (toggleMenu = false)">
							<router-link
								class="profile-menu-mobile__link"
								:to="{ name: 'profile' }"
							>
								<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'profile-menu-mobile__svg'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M14.3 14.06l-.18-.06a7.1 7.1 0 003-6 5.07 5.07 0 00-5-5 5.07 5.07 0 00-5 5 7.11 7.11 0 003 6l-.18.09c-3.37 1.5-6.86 3-5.79 6.26l.22.68h15.5l.22-.68c1.07-3.24-2.42-4.79-5.79-6.29zM9.14 8a3 3 0 016 0c0 2.07-.89 3.59-3 4.92-2.14-1.33-3-2.85-3-4.92zM6 19c.18-.77 1.31-1.57 4.77-3.11.48-.22.92-.43 1.34-.66.42.23.87.44 1.35.66 3.54 1.54 4.62 2.34 4.79 3.11z"/></svg>
								{{ $t('profile.subHeaderText') }}
							</router-link>

							<router-link
								class="profile-menu-mobile__link"
								:to="{ name: 'bookings' }"
							>
								<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" v-bind:svg-inline="''" v-bind:class="'profile-menu-mobile__svg'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="st0" d="M17 14V0H0v17c0 2.2 1.8 4 4 4h12c2.2 0 4-1.8 4-4v-3h-3zM6 17c0 1.1-.9 2-2 2s-2-.9-2-2V2h13v12H6v3zm12 0c0 1.1-.9 2-2 2H7.5c.3-.6.5-1.3.5-2v-1h10v1z"/><path class="st0" d="M10 10H4c-.3 0-.5.2-.5.5s.2.5.5.5h6c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM13 7H4c-.3 0-.5.2-.5.5s.2.5.5.5h9c.3 0 .5-.2.5-.5S13.3 7 13 7zM4 5h8c.3 0 .5-.2.5-.5S12.3 4 12 4H4c-.3 0-.5.2-.5.5s.2.5.5.5z"/></svg>
								{{ $t('profile.overviewBookingsTitle') }}
							</router-link>
							<router-link
								class="profile-menu-mobile__link"
								:to="{ name: 'guests' }"
							>
								<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'profile-menu-mobile__svg'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M9.38 14.06L9.19 14a7.09 7.09 0 003-6 5.07 5.07 0 00-5-5 5.07 5.07 0 00-5 5 7.11 7.11 0 003 6l-.19.09C1 15.86-.8 17.31.21 20.35a1 1 0 001 .68h12a1 1 0 00.95-.68c1.02-3.07-.81-4.52-4.78-6.29zM4.22 8a3 3 0 013-3 3 3 0 013 3c0 2.07-.89 3.59-3 4.92-2.1-1.33-3-2.85-3-4.92zm8.23 11H2c-.08-.8.5-1.61 3.88-3.11.47-.22.92-.43 1.34-.66.42.23.87.44 1.35.66 3.43 1.5 3.96 2.31 3.88 3.11z"/><path d="M18.81 14.7a6.31 6.31 0 002.56-5.2 4.54 4.54 0 00-9.07 0c0 2.64 1.25 4.59 4 6.18h.06c.49.28 1 .55 1.61.81 2.73 1.2 3.34 1.86 3.36 2.48h-4.5a1 1 0 000 2h5.3a1 1 0 00.95-.68c.92-2.7-.79-4.06-4.27-5.59zm-2-1c-2.19-1.41-2.54-2.82-2.54-4.16a2.54 2.54 0 015.07 0 4.64 4.64 0 01-2.5 4.12z"/></svg>
								{{ $t('profile.overviewGuestsTitle') }}
							</router-link>
							<router-link
								class="profile-menu-mobile__link"
								:to="{ name: 'edit' }"
							>
								<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" v-bind:svg-inline="''" v-bind:class="'profile-menu-mobile__svg'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="st0" d="M17.9 7.2h-.7c0-.1-.1-.2-.1-.3l.5-.5c.8-.8.8-2.2 0-3l-1-1c-.8-.8-2.2-.8-3 0l-.5.5c-.1 0-.2-.1-.3-.1v-.7c0-1.2-1-2.1-2.1-2.1H9.3C8.2 0 7.2 1 7.2 2.1v.7c-.1 0-.2.1-.3.1l-.5-.4c-.8-.8-2.2-.8-3 0l-1 1c-.8.8-.8 2.2 0 3l.5.5c0 .1-.1.2-.1.3h-.7C1 7.2 0 8.2 0 9.3v1.4c0 1.2 1 2.1 2.1 2.1h.7c0 .1.1.2.1.3l-.5.5c-.8.8-.8 2.2 0 3l1 1c.8.8 2.2.8 3 0l.5-.5c.1 0 .2.1.3.1v.7c0 1.2 1 2.1 2.1 2.1h1.3c1.2 0 2.1-1 2.1-2.1v-.7c.1 0 .2-.1.3-.1l.5.5c.8.8 2.2.8 3 0l1-1c.8-.8.8-2.2 0-3l-.5-.5c0-.1.1-.2.1-.3h.7c1.2 0 2.1-1 2.1-2.1V9.3c.1-1.1-.9-2.1-2-2.1zm.1 3.5c0 .1-.1.1-.1.1h-1.4c-.5 0-.8.3-1 .7-.1.4-.3.9-.5 1.3s-.2.9.2 1.2l1 1v.2l-1 1H15l-1-1c-.3-.3-.8-.4-1.2-.2-.4.2-.8.4-1.3.5-.4.1-.7.5-.7 1v1.4c0 .1-.1.1-.1.1H9.3c-.1 0-.1-.1-.1-.1v-1.4c0-.5-.3-.8-.7-1-.5-.1-.9-.3-1.3-.5-.2-.1-.3-.1-.5-.1-.3 0-.5.1-.7.3l-1 1h-.2l-1-1V15l1-1c.3-.3.4-.8.2-1.2-.2-.4-.4-.8-.5-1.3-.1-.4-.5-.7-1-.7H2.1c-.1 0-.1-.1-.1-.1V9.3c0-.1.1-.1.1-.1h1.4c.5 0 .8-.3 1-.7.1-.5.3-.9.5-1.3s.2-.9-.1-1.2l-1-1v-.2l1-1h.2l1 1c.2.4.7.4 1.1.2.4-.2.8-.4 1.3-.5.4-.1.7-.5.7-1V2.1l.1-.1h1.3c.1 0 .1.1.1.1v1.4c0 .5.3.8.7 1 .6.1 1 .3 1.4.5.4.2.9.2 1.2-.2l1-1h.2l1 1V5l-1 1c-.3.3-.4.8-.2 1.2.2.4.4.8.5 1.3.1.4.5.7 1 .7h1.4c.1 0 .1.1.1.1v1.4z"/><path class="st0" d="M10 7c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/></svg>
								{{ $t('profile.settingsTitle') }}
							</router-link>
							<div
								class="profile-menu-mobile__click-outside"
								@click="() => (toggleMenu = false)"
							></div>
						</div>
					</div>
				</div>
			</div>
		</transition-expand>
	</div>
</template>
<script>
import TransitionExpand from '../atoms/TransitionExpand'

export default {
	name: 'ProfileMenuMobile',
	components: {
		TransitionExpand
	},
	props: {
		header: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			toggleMenu: false
		}
	},
	methods: {
		toggle() {
			this.toggleMenu = !this.toggleMenu
		}
	},
	created() {}
}
</script>

<style lang="scss">
.profile-menu-mobile {
	@include for-tablet-portrait-up {
		display: none;
	}
	position: relative;
	z-index: 1;
	&__header {
		margin-top: -20px;
		height: 60px;
		background-color: #546482;
		font-size: 18px;
		font-weight: 500;
		letter-spacing: 0;
		line-height: 16px;
		color: $colorWhite;
	}
	&__click-outside {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: -1;
	}
	&__toggle {
		background: none;
		border: 0;
		svg {
			width: 20px;
			height: 12px;
		}
	}
	&__title {
		display: flex;
		align-items: center;
		height: 60px;
		justify-content: space-between;
	}
	&__item {
		position: absolute;
		margin-top: -1px;
		width: 100%;
		background: #697791;
		box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.2);
	}
	&__link {
		display: flex;
		position: relative;
		font-weight: 500;
		align-items: center;
		padding: 10px 0px 10px 0px;
		color: $colorPrimary3;
		&:first-child {
			padding: 15px 0px 10px 0px;
		}
		&:last-child {
			padding: 10px 0px 25px 0px;
		}
		svg {
			width: 20px;
			height: 24px;
			margin-right: 12px;
		}
	}
	&__svg {
		&--down {
			fill: $colorWhite;
		}
		&--up {
			fill: $colorSecondary;
		}
	}
	a.profile-menu-mobile__link {
		color: $colorPrimary3;
	}
	a.profile-menu-mobile__link.router-link-exact-active {
		color: $colorWhite;
	}
	a.profile-menu-mobile__link svg {
		fill: $colorPrimary3;
	}
	a.profile-menu-mobile__link.router-link-exact-active svg {
		fill: $colorWhite;
	}
}
</style>
